export default __webpack_public_path__ + "assets/img/iso_light.svg";